import { AuthHelpers, useAuthHelper } from '@salesforce/commerce-sdk-react';
import { isServer, useMutation } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import type { RegisterCustomerDTO } from '../../pages/account/model/RegisterCustomerDTO';

export const useCustomerRegistration = (): UseMutationResult<
    unknown,
    unknown,
    RegisterCustomerDTO
> => {
    const register = useAuthHelper(AuthHelpers.Register);

    return useMutation<unknown, unknown, RegisterCustomerDTO>({
        mutationFn: async (data) => {
            if (!isServer) await window.sfccSessionCreationPromise;

            const body = {
                customer: {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    email: data.email,
                    login: data.email,
                },
                password: data.password ?? '',
            };

            await register.mutateAsync(body);
        },
    });
};
